import React, {Component} from "react";
import {useState, useEffect} from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useNavigate} from 'react-router-dom';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';

export default function BasicModal(props) {
    const navigate = useNavigate()

    const [open, setOpen] = useState(false);

  
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
            setOpen(false)
            props.setisDialogOpened(false)
            navigate('/logout', { replace: true })
    }

    useEffect(()=>{
        handleOpen()
    },[])





  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
            <div className="myModal fadefx">
                <div className="container">
                    <div className="errIcon">
                        <CheckCircleIcon/>
                    </div>
                    <div className="errbody">
                    <p><b>Your account has been deleted successfully</b><br/><br/>
                            Thanks for your support, wish you all the best.</p><br/>

                        <Button onClick={()=>handleClose()}  className="btn">Okay</Button>
                        <Button onClick={()=>handleClose()} className="btn closebtn">Close</Button>
                    </div>
                </div>
            </div>
         
      </Modal>
  );
}



